import { defineStore } from 'pinia'
import { ref } from 'vue'
import { sleep } from '@/utils'

export const useFlasherStore = defineStore('flasher', () => {
  const flashing = ref(false)
  const flash = ref(false)

  const start = async (duration: number = 15) => {
    if (flashing.value) {
      return
    }
    flashing.value = true
    for (let i = 0; i < duration; i++) {
      flash.value = !flash.value
      await sleep(1000)
    }
    flash.value = false
    flashing.value = false
  }

  return { flash, start }
})
